import { Injectable } from '@angular/core';
import { Routes } from '@angular/router';

import { MenuItem, MenuSection } from '../../core/models/menu-item.model';
import { MenuRegistryService } from '../../core/services/menu-registry.service';
import { LANDING_INSPECTION_ROUTES } from './landing-inspection.routes';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

const menuItems: MenuItem[] = [
  {
    id: 'landing-inspection',
    name: 'Inspecciones ',
    type: 'form',
    dataSource: { url: 'inspections/landing-inspection' },
    icon: 'description',
    order: 1,
    neededClaim: getClaimString(AppFeature.InspectionsFids, AppActions.Read),
  },
  {
    id: 'shark-details',
    name: 'Detalle de Tiburones',
    type: 'form',
    dataSource: { url: 'inspections/shark-details' },
    icon: 'tsunami',
    order: 2,
    neededClaim: getClaimString(AppFeature.InspectionsSharks, AppActions.Read),
  },
  {
    id: 'scale-details',
    name: 'Detalles otras especies',
    type: 'form',
    dataSource: { url: 'inspections/scale-details' },
    icon: 'hub',
    order: 3,
    neededClaim: getClaimString(AppFeature.InspectionsScale, AppActions.Read),
  },
];

const menuSection: MenuSection = {
  id: 'landing-inspection',
  name: 'Fiscalización',
  items: menuItems,
  order: 2,
  neededClaim: getClaimString(AppFeature.Inspections, AppActions.Read),
};

@Injectable({
  providedIn: 'root',
})
export class LandingInspectionModule {
  constructor(private menuRegistry: MenuRegistryService) {
    // Self-register menu items only
    // Routes are now handled by standard Angular routing in app.routes.ts
    this.menuRegistry.registerModule(menuSection);
  }

  /**
   * Static method to get menu items (for external access)
   */
  static getMenuItems(): MenuItem[] {
    return menuItems;
  }

  /**
   * Static method to get routes (for external access)
   */
  static getRoutes(): Routes {
    return LANDING_INSPECTION_ROUTES;
  }
}
